import { Component, computed, effect, inject, signal } from '@angular/core';
import { TranslationService } from '@core/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { locale } from '../../i18n/en';
import { ToastStackService } from '../../services/toast-stack.service';
import { ToastStackItemComponent } from '../toast-stack-item/toast-stack-item.component';

@Component({
    selector: 'toast-stack',
    templateUrl: './toast-stack.component.html',
    styleUrl: './toast-stack.component.scss',
    imports: [ToastStackItemComponent, TranslateModule],
})
export class ToastStackComponent {
    private readonly toastStack = inject(ToastStackService);
    private readonly translationService = inject(TranslationService);

    readonly items = this.toastStack.items;
    readonly position = this.toastStack.position;
    readonly verticalPosition = this.toastStack.verticalPosition;
    readonly maxVisibleLayers = this.toastStack.maxVisibleLayers;
    readonly isExpanded = signal(false);
    readonly offsetPx = computed(() => 40 + this.toastStack.bottomOffset());

    constructor() {
        this.translationService.loadTranslations(locale);

        effect(() => {
            if (this.items().length === 0) {
                this.isExpanded.set(false);
            }
        });
    }

    onMouseEnter(): void {
        this.isExpanded.set(true);
    }

    onMouseLeave(): void {
        this.isExpanded.set(false);
    }

    onClear(id: string): void {
        this.toastStack.clear(id);
    }

    onClearAll(): void {
        this.toastStack.clearAll();
    }
}
